import React, { Component } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

export default class KeyFeatures extends Component {
  constructor(props) {
    super(props);
    this.state = {
      keyfeatures: [
        {
          id: 1,
          icon: "uil uil-layer-group d-block rounded h3 mb-0",
          hoverIcon: "uil uil-layer-group text-primary full-img",
          title: "Modulaire",
          desc: "Des conceptions performantes dans tous les environnements.",
          link: "http://www.prosygma.com/iishelp/iis/htm/asp/perf6o37.htm"
        },
        {
          id: 2,
          icon: "uil uil-airplay d-block rounded h3 mb-0",
          hoverIcon: "uil uil-airplay text-primary full-img",
          title: "Responsive",
          desc: "Conçu de façon à pouvoir s'adapter à toutes les résolutions d'écrans.",
          link: "https://www.multimed-solutions.com/blog/definition-site-responsive/"
        },
        {
          id: 3,
          icon: "uil uil-focus-target d-block rounded h3 mb-0",
          hoverIcon: "uil uil-focus-target text-primary full-img",
          title: "Personnalisable",
          desc: "Vous êtes le maître de votre projet, il doit vous ressembler.",
          link: "https://www.e-marketing.fr/Thematique/cross-canal-1094/breve/personnalisation-dun-site-web-une-demarche-plus-compliquee-que-vous-ne-le-pensez-328235.htm"
        },
        {
          id: 4,
          icon: "uil uil-expand-arrows d-block rounded h3 mb-0",
          hoverIcon: "uil uil-expand-arrows text-primary full-img",
          title: "Scalable",
          desc: "Des créations évolutives adaptées à votre entreprise, qui évoluent avec vous.",
          link: "https://wydden.com/startup-scalabilite/"
        },
      ],
    };
  }
  render() {
    return (
      <React.Fragment>
        <Row>
          <Col xs={12}>
            <div className="section-title mb-4 pb-2">
              <h4 className="title mb-4">Quelques caractéristiques</h4>
              <p className="para-desc text-muted mb-0">
                Je m'assure de vous créer le site qui conviendra à vos
                besoins et qui répondra aux normes de nos jours.
              </p>
            </div>
          </Col>
        </Row>

        <Row className=" align-items-center">
          {this.state.keyfeatures.map((keyfeatures, key) => (
            <Col lg={3} md={6} className="mt-4 pt-2" key={key}>
              <Card className="border-0 features feature-clean course-feature p-4 overflow-hidden shadow">
                <div className="icons text-primary text-center">
                  <i className={keyfeatures.icon} />
                </div>
                <CardBody className="p-0 mt-4">
                  <a href={keyfeatures.link} target="_blank" rel="noreferrer" className="title h5 text-dark">
                    {keyfeatures.title}
                  </a>
                  <p className="text-muted mt-2">
                    {keyfeatures.desc}
                  </p>
                  <a href={keyfeatures.link} target="_blank" rel="noreferrer" className="text-primary read-more">
                    En lire plus <i className="mdi mdi-chevron-right" />
                  </a>
                  <i className={keyfeatures.hoverIcon} />
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </React.Fragment >
    );
  }
}
